import { IncomingMessage } from "http";
import { Locale } from "./i18n";

export enum Subdomain {
  WWW = "www",
  TW = "tw",
  HK = "hk",
  JA = "ja",
  CN = "cn",
  AU = "au",
}

const getLocaleFromSubdomain = (subdomain: Subdomain): Locale => {
  switch (subdomain) {
    case Subdomain.TW:
      return Locale.ZH_TW;
    case Subdomain.HK:
      return Locale.ZH_HK;
    case Subdomain.WWW:
      return Locale.EN;
    case Subdomain.JA:
      return Locale.JA;
    case Subdomain.CN:
      return Locale.CN;
    case Subdomain.AU:
      return Locale.EN_AU;
  }
};

const getSubdomainFromUrl = (hostname: string): Subdomain => {
  const subdomain = hostname.split(".")[0];

  switch (subdomain) {
    case "ja":
      return Subdomain.JA;
    case "tw":
      return Subdomain.TW;
    case "hk":
      return Subdomain.HK;
    case "www":
      return Subdomain.WWW;
    case "cn":
      return Subdomain.CN;
    case "au":
      return Subdomain.AU;
    default:
      return Subdomain.TW;
  }
};

const getSubdomainFromNextLocale = (locale: string | undefined): Subdomain => {
  switch (locale) {
    case 'tw':
      return Subdomain.TW;
    case 'hk':
      return Subdomain.HK;
    case 'www':
      return Subdomain.WWW;
    case 'jp':
      return Subdomain.JA;
    case 'cn':
      return Subdomain.CN;
    case 'weapp':
      return Subdomain.CN;
    case "au":
      return Subdomain.AU;
    default:
      return Subdomain.WWW;
  }
}

export { getLocaleFromSubdomain, getSubdomainFromNextLocale };